const validate = values => {
	const errors = {}
	if (!values.document_number) {
		errors.document_number = 'Este Campo es Obligatorio'
	}
	if (values.document_number && !/(\d{7}|\d{8})$/.test(values.document_number)) {
		errors.document_number = 'El documento no es válido'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/validationsCarSimulation.js
 **/